// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { ChangeEvent } from "react";

import { ReviewState } from "../store/schema";
import { createOuts } from "../util";

const { debug } = createOuts("ReviewStateChooser", true);

interface ReviewStateChooserProps {
  htmlId?: string;
  reviewState: ReviewState;
  disabled?: boolean;
  onChange: (reviewState: ReviewState) => void;
}

export const ReviewStateChooser: React.FC<ReviewStateChooserProps> = ({
  htmlId,
  reviewState,
  disabled,
  onChange,
}) => {
  function updateReviewState(e: ChangeEvent<HTMLSelectElement>) {
    const reviewState = e.target.value as ReviewState;
    debug(`chose ${reviewState}`);
    onChange(reviewState);
  }

  debug(`current=${reviewState}`);
  const choices = [
    simpleChoice(ReviewState.Approved),
    simpleChoice(ReviewState.Pending),
    simpleChoice(ReviewState.Rejected),
  ];

  return (
    <select id={htmlId} onChange={updateReviewState} value={reviewState} disabled={!!disabled}>
      {choices.map(x => (
        <option key={x.key} value={x.key}>
          {x.label}
        </option>
      ))}
    </select>
  );
};

function simpleChoice(key: string) {
  return { key, label: key };
}
